module.exports = __webpack_public_path__ + "media/stylesheets/images/media/advertising_kurashino_bg-feeaf3aba38695c7114aa2f7bdfb1074.jpg";